import templateUrl from "emun.order/order-details-actions.htm";

export default () => ({ templateUrl });
